import { Directive, inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Directive({
  selector: '[ifNative]'
})
export class IfNativeDirective {
  templateRef = inject(TemplateRef<any>)
  viewContainer = inject(ViewContainerRef)

  constructor() {
    // Check if running in native platform (iOS, Android, etc.)
    if (Capacitor.getPlatform() !== 'web') {
      // Create the embedded view (render the element)
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      // Clear the view (do not render)
      this.viewContainer.clear();
    }
  }

}
